module.exports = __webpack_public_path__ + "static/henho8-ff9184f765d47590c0e12e2573abd56d.jpg";